<template>
  <v-card v-if="hasContent" class="areas-form-hint" flat>
    <v-card-text class="areas-form-hint__body py-3 px-3">
      <div class="areas-form-hint__title">
        <v-icon small color="#4c6c93" class="mr-1">mdi-lightbulb-on-outline</v-icon>
        <span>{{ title }}</span>
      </div>
      <div class="areas-form-hint__rows">
        <div v-for="(row, index) in rows" :key="index" class="areas-form-hint__row">
          <span class="areas-form-hint__label">{{ row.label }}</span>
          <span class="areas-form-hint__value">{{ row.value }}</span>
        </div>
      </div>
      <div v-if="extra" class="areas-form-hint__extra mt-2">{{ extra }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'AreasFormHint',
  props: {
    title: {
      type: String,
      default: 'Выбрано',
    },
    rows: {
      type: Array,
      default: () => [],
    },
    extra: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasContent () {
      return (this.rows && this.rows.length > 0) || !!this.extra;
    },
  },
};
</script>

<style lang="scss" scoped>
.areas-form-hint {
  border-radius: 12px;
  background: linear-gradient(180deg, #f7fafc 0%, #f1f6fa 100%);
  border: 1px solid #dce6ef;
}

.areas-form-hint__body {
  font-size: 0.8125rem;
  line-height: 1.45;
}

.areas-form-hint__title {
  display: flex;
  align-items: center;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #4c6c93;
  margin-bottom: 8px;
}

.areas-form-hint__rows {
  display: grid;
  gap: 6px;
}

.areas-form-hint__row {
  display: grid;
  grid-template-columns: minmax(110px, 38%) 1fr;
  gap: 8px;
  align-items: baseline;
}

.areas-form-hint__label {
  color: #78909c;
}

.areas-form-hint__value {
  color: #37474f;
  font-weight: 500;
}

.areas-form-hint__extra {
  color: #607d8b;
  font-size: 0.75rem;
  line-height: 1.45;
  padding-top: 8px;
  border-top: 1px dashed #d5e0ea;
}

@media screen and (max-width: 600px) {
  .areas-form-hint__row {
    grid-template-columns: 1fr;
    gap: 2px;
  }
}
</style>
